import { mapGetters } from 'vuex';

import { getFieldLocale } from '@/utils/field';

/**
 * Metric name priority
 * 1. Custom Metric (GET /customMetrics)
 * 2. Alias (GET /fieldPreferences)
 * 3. Locale from BE (POST /availableFields/v2)
 * 4. Locale from FE
 */
export default {
    name: 'metricTranslatorMixin',
    computed: {
        ...mapGetters('user', ['isQa']),
        ...mapGetters('newDashboard', [
            'aliasesByIndex',
            'customMetricsConverted',
        ]),
    },
    methods: {
        getCustomMetricName(key) {
            return (
                this.customMetricsConverted[key] ||
                this.$t(`COMMON.deleted_field`)
            );
        },
        getMetricAliasName(key) {
            return this.aliasesByIndex[key]?.displayFieldName;
        },

        /**
         * 메인 함수
         */
        _getMetricName(metric) {
            const { getCustomMetricName, getMetricAliasName } = this;
            const {
                key,
                isCustom,
                locale: localeFromBE,
                useAlias = true,
            } = metric;

            return isCustom
                ? getCustomMetricName(key)
                : (useAlias && getMetricAliasName(key)) ||
                      localeFromBE ||
                      getFieldLocale.call(this, key);
        },
        _getMetricNameWithRawName(metric) {
            const { _getMetricName } = this;
            const { key } = metric;

            return `[${key}]-${_getMetricName(metric)}`;
        },
        getMetricName(metric) {
            const { isQa, _getMetricName, _getMetricNameWithRawName } = this;
            return isQa
                ? _getMetricNameWithRawName(metric)
                : _getMetricName(metric);
        },
    },
};
